// extracted by mini-css-extract-plugin
export default {"iconLogo":"PlatformIcon_iconLogo__03zGM","iconLogoT":"PlatformIcon_iconLogoT__bGVEw"};